import notificationService from "../../../../services/NotificationService";
import SelectDisplayManager from "./selectDisplayManager";
import { useTranslation } from "react-i18next";

const SelectManager = ({
    selectedTemplates,
    replaceSelectedTemplate,
    deleteSelectedTemplate,
    updateSelectedTemplate,
    priceOptions,
}) => {
    const { t } = useTranslation("templatesPage");
    const removeSelectedTemplate = async (item) => {
        // Step 1: Set template to loading
        replaceSelectedTemplate({ ...item, isLoading: true });

        // Step 2: remove template
        const isDeleted = await deleteSelectedTemplate(item);

        // Step 3: update if not deleted
        if (!isDeleted) replaceSelectedTemplate({ ...item, isLoading: false });
    };

    const removeSelectedTemplateQuestion = (item) => {
        notificationService.setMessage(
            t("selectedPageUnselect", {
                title: item.name ? item.name : item.title,
            }),
        );
        notificationService.setTitle(t("unselectButton"));
        notificationService.onClick(() => {
            //reset the window
            notificationService.clearAll();
            removeSelectedTemplate(item);
        });
    };

    const updateSelectedTemplateComponent = async (item) => {
        // Step 1: Set template to loading
        replaceSelectedTemplate({ ...item, isLoading: true });

        // Step 2: attemped to update new values
        await updateSelectedTemplate(
            item,
            item.newPrice ? item.newPrice : item.price,
            item.newName ? item.newName : item.name,
        );

        // Step 3: Reset template state
        replaceSelectedTemplate({
            ...item,
            isLoading: false,

            //Step 3 - 1: Reset input values for display
            newPrice: null,
            newName: null,
            changed: false,
        });
    };

    // Initialize an array to hold the template components
    let arr = [];

    // Step 1: Check if there are selected templates
    if (selectedTemplates.length) {
        selectedTemplates.forEach((item) => {
            // Step 2: Create the content for each template using SelectDisplayManager component
            const content = (
                <SelectDisplayManager
                    item={item}
                    replaceSelectedTemplate={replaceSelectedTemplate}
                    updateSelectedTemplateComponent={
                        updateSelectedTemplateComponent
                    }
                    removeSelectedTemplateQuestion={
                        removeSelectedTemplateQuestion
                    }
                    priceOptions={priceOptions}
                />
            );

            // Step 3: Wrap the content in a <div> with a unique key and push it to the array
            arr.push(<div key={item.id}>{content}</div>);
        });
    }

    // Step 4: Define the message to display when no templates are selected
    const displayTextForNoTemplates = (
        <p className="selectedTemplatesDisplayTextForNoImagesSelected">
            You currently have no templates selected
        </p>
    );

    // Step 5: Return either the array of components or the "no templates" message
    return (
        <div className="selectedTemplatesDisplayContainerElements">
            {arr.length ? arr : displayTextForNoTemplates}
        </div>
    );
};

export default SelectManager;
